import { render } from "./VabeneOrderListPage.vue?vue&type=template&id=16aefb48&ts=true"
import script from "./VabeneOrderListPage.vue?vue&type=script&lang=ts"
export * from "./VabeneOrderListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__